var _metadata, _sodipodiNamedview, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskDescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 19.999999 20",
    sodipodiDocname: "description.svg",
    width: 20,
    height: 20,
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1137,
    id: "namedview12",
    showgrid: "false",
    inkscapeZoom: 2.2425732,
    inkscapeCx: -22.055926,
    inkscapeCy: 175.70734,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "Layer_1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none;}.cls-2{fill:#717272;}"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-sticky-note",
    "data-name": "Icon awesome-sticky-note",
    transform: "matrix(0.24805689,0,0,0.24830276,-64.377029,-87.958883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 312.9,404.93 h 18.34 v -35.6 a 3.22,3.22 0 0 0 -3.22,-3.22 h -54 a 3.23,3.23 0 0 0 -3.23,3.22 v 53.94 a 3.23,3.23 0 0 0 3.23,3.22 h 35.61 v -18.31 a 3.25,3.25 0 0 1 3.27,-3.25 z m 17.39,7.42 -13.21,13.22 a 3.24,3.24 0 0 1 -2.29,0.94 H 314 v -17.26 h 17.26 v 0.8 a 3.29,3.29 0 0 1 -0.94,2.3 z",
    id: "path6",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 303.62,420.47 v -12.3 a 9.29,9.29 0 0 1 9.28,-9.28 h 12.3 v -26.75 h -48.34 v 48.33 h 26.76 m 11.17,6 H 314 v -17.22 h 17.26 v 0.82 a 3.23,3.23 0 0 1 -0.95,2.28 l -13.21,13.22 a 3.26,3.26 0 0 1 -2.31,0.94 z m -5.13,0 h -35.6 a 3.23,3.23 0 0 1 -3.24,-3.24 v -53.9 a 3.23,3.23 0 0 1 3.24,-3.23 H 328 a 3.22,3.22 0 0 1 3.24,3.23 v 35.6 H 312.9 a 3.25,3.25 0 0 0 -3.24,3.24 z",
    id: "path8",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#717272"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDescriptionIcon);
export default __webpack_public_path__ + "static/media/task-description-icon.ac055dc6fa8534ae09af0e64a3392667.svg";
export { ForwardRef as ReactComponent };